import React, { useState } from 'react';

import Image from 'next/image';

import Game from './Game';
import WinLayout from '../../components/Winlayout';
import { core } from '../localization/core';

const MainView = ({ setView }: { setView: (view: number) => void }) => {
  const [show, setShow] = useState(false);

  return (
    <div className='min-h-screen bg-[url("/img/v2/register/sportBg.webp")] bg-cover '>
      <main className="flex flex-col items-center justify-center h-full">
        <Image src="/img/v2/register/nameSport.webp" alt="bgCasino" width={300} height={300} className="mt-8" />

        {/* Title */}
        <div className="flex flex-col items-center justify-center gap-1 mt-5">
          <h3 className="text-white text-2xl font-bold">{core.title}</h3>
          <p className="text-white text-sm font-medium">{core.description}</p>
        </div>

        <Game setShow={setShow} />
        <div className="absolute bottom-5 left-1">
          <Image src="/img/v2/register/hondu.webp" alt="Powerbet" width={150} height={150} className="mt-8 z-50" />
        </div>
      </main>
      <WinLayout show={show} setView={setView} onClose={() => { return setShow(false); }} view="sport" />
    </div>
  );
};

export default MainView;
